export default "__VITE_ASSET__CVpzwWkd__"